import {
  safeJsonParse,
  safeJsonStringify,
} from './dataConverter';

const isBrowser = (typeof window !== 'undefined');

const noop = () => {};
const mockStorage = {
  get: noop,
  set: noop,
  remove: noop,
  clear: noop,
};

const seesionStorageObj = isBrowser
  ? window.sessionStorage
  : mockStorage;
const localStorageObj = isBrowser
  ? window.localStorage
  : mockStorage;

class Storage {
  constructor(opt = {}) {
    const {
      prefix = '@avenuebank-',
      type = 'session',
    } = opt;

    this.prefix = prefix;

    this.storage = type === 'session'
      ? seesionStorageObj
      : localStorageObj;
  }

  get(key = '') {
    const ret = this.storage.getItem(`${this.prefix}${key}`);
    return safeJsonParse(ret);
  }

  set(key = '', value = '') {
    if (!key) {
      return;
    }

    this.storage.setItem(`${this.prefix}${key}`, safeJsonStringify(value));
  }
}

export default Storage;
